import Box from '@mui/material/Box';
import type { AccountType } from '@safc/api-client';
import { AccountTypeToLabel } from '@safc/configuration';
import { Icon } from 'assets/Icon.js';
import { getAccountIcon } from 'shared/context/getAccountIcon.js';

import {
  AccountAvatar,
  AccountName,
  AccountsListButton,
  AccountTypeLabel,
} from './IssueModal.styled.js';

interface AccountProps {
  name: string;
  type: AccountType;
  onClick?: VoidFunction;
}

export const Account = ({ name, onClick, type }: AccountProps) => {
  return (
    <AccountsListButton disableRipple onClick={onClick}>
      <Box mr={1.6}>
        <AccountAvatar>
          <Icon sx={{ fontSize: 32 }} icon={getAccountIcon(type)} />
        </AccountAvatar>
      </Box>

      <Box>
        <AccountName>{name}</AccountName>
        <AccountTypeLabel>{AccountTypeToLabel[type]}</AccountTypeLabel>
      </Box>
    </AccountsListButton>
  );
};
